/**
 * A single note in a pattern part
 */
export type PatternNote = {
  note: string | null; // e.g. "C2", "E2", or null for rest
  duration: string; // Tone.js duration e.g. "4n", "8n"
};

/**
 * A pattern part is a 1-bar sequence of notes
 */
export type PatternPart = PatternNote[];

/**
 * All generated pattern parts (A, B, C, D, E)
 */
export type PatternParts = {
  A: PatternPart;
  B: PatternPart;
  C?: PatternPart;
  D?: PatternPart;
  E?: PatternPart;
};

/**
 * Available pattern types
 */
export type Pattern = {
  name: string; // e.g. "ABAB"
  sequence: string[]; // e.g. ["A", "B", "A", "B"]
};

/**
 * Common Western music patterns
 */
export const PATTERNS: readonly Pattern[] = [
  { name: "A", sequence: ["A"] },
  { name: "AB", sequence: ["A", "B"] },
  { name: "AABB", sequence: ["A", "A", "B", "B"] },
  { name: "AABC", sequence: ["A", "A", "B", "C"] },
  { name: "ABCB", sequence: ["A", "B", "C", "B"] },
  { name: "ABCD", sequence: ["A", "B", "C", "D"] },
  { name: "AAB", sequence: ["A", "A", "B"] },
  { name: "ABC", sequence: ["A", "B", "C"] },
  { name: "AABAAC", sequence: ["A", "A", "B", "A", "A", "C"] },
  { name: "AABCCD", sequence: ["A", "A", "B", "C", "C", "D"] },
] as const;
